import { combineReducers } from '@reduxjs/toolkit'

//admin
import adminSettingReducer from '../admin/redux/settings/slice'
import adminNavReducer from '../admin/redux/nav/slice'
import adminAuthReducer from '../admin/redux/auth/slice'
import adminProviderManagement from '../admin/redux/providerManagement/slice'
import adminCMS from '../admin/redux/cms/slice'
import adminManageStore from '../admin/redux/manageStore/slice'
import adminOrderManagement from '../admin/redux/orderManagement/slice'
import adminOther from '../admin/redux/other/slice'
import adminMarketPlace from '../admin/redux/marketplace/slice'
import adminService from '../admin/redux/adminServices/slice'
import jobManagement from '../admin/redux/jobManagement/slice'
import gigManagement from '../admin/redux/gigManagement/slice'
import vehicleManagement from '../admin/redux/vehicleManagement/slice'
import feedbackManagement from '../admin/redux/feedbackManagement/slice'

//main
import mainAuthReducer from '../main/redux/auth/slice'

import companyAuthReducer from '../company/redux/auth/slice'
import companyNavReducer from '../company/redux/nav/slice'
import healthcareReducer from '../admin/redux/healthcareManagement/slice'

// Event Management
import eventReducer from '../admin/redux/eventManagement/slice'

const appReducer = combineReducers({
  adminNavReducer,
  adminAuthReducer,
  adminSettingReducer,
  adminProviderManagement,
  adminOther,
  adminManageStore,
  adminCMS,
  adminOrderManagement,
  mainAuthReducer,
  companyAuthReducer,
  companyNavReducer,
  adminMarketPlace,
  adminService,
  jobManagement,
  healthcareReducer,
  eventReducer,
  gigManagement,
  vehicleManagement,
  feedbackManagement,
})

const rootReducer = (state, action) => {
  if (action?.type === 'auth/userLogout') {
    return appReducer(undefined, action)
  }

  return appReducer(state, action)
}

export default rootReducer
